import type { CatalogCategoryResponse } from 'src/entities/catalog'
import { defineStore } from 'pinia'

interface IState {
  catalog: CatalogCategoryResponse[] | null
}

export const useCatalogStore = defineStore('catalog', {
  state: (): IState => ({
    catalog: null,
  }),
  actions: {
    setCatalog(list: CatalogCategoryResponse[]) {
      this.catalog = list
    },
  },
})
